<template>
  <div>
    <label
      for="call_queue_group_id"
      class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
    >
      {{ $t("Files") }}
    </label>
    <div class="mt-1 sm:mt-0 sm:col-span-2">
      <InputSearchSelector
        :key="selectedPbxElements"
        v-model:searchElement="searchElement"
        :searchData="queueListSliced"
        :infiniteHandler="infiniteHandler"
        :selected="selectedPbxElements"
        urlType="queue"
        :addElement="addElement"
        :slicedListIncludes="slicedListIncludes"
        :elementListConcatReduce="elementsData"
        :groupSelectedFromPbxConfiguration="groupSelectedFromPbxConfiguration"
      />
    </div>
    <div class="flex items-center justify-between mt-1 px-1 mb-2">
      <button
        @click.prevent="$emit('selectAll', queueList)"
        class="text-sm text-gray-500"
      >
        {{ $t("selectAll") }}
      </button>
      <button
        @click.prevent="$emit('clearForm')"
        class="text-sm text-blue-600 capitalize"
      >
        {{ $t("clear") }}
      </button>
    </div>
    <!-- <div
      v-for="element in isEdit ? elementsFromEdit : selectedPbxElements"
      :key="element.value"
      class="relative rounded-lg border border-gray-300 bg-white px-2 py-1 shadow-sm flex items-center hover:border-gray-400 gap-1 mt-1 mb-1"
    >
      <div @click="addElement(element)" class="flex-1 min-w-0">
        <a title="Remove element" class="focus:outline-none cursor-pointer">
          <span class="absolute inset-0" aria-hidden="true" />
          <p class="text-xs font-normal text-gray-900">
            {{ element.label }}
          </p>
        </a>
      </div>
    </div> -->
  </div>
  <!-- <div class="pt-5">
      <div class="flex justify-end">
        <a
          href="javascript:void(0)"
          @click="this.$emit('closeForm')"
          class="rounded bg-white py-2 px-4 border border-gray-300 shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50"
        >
          {{ $t("ticket.cancel") }}
        </a>
        <button
          type="submit"
          class="rounded ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium body__header--button text-white capitalize"
        >
          {{ $t("validate") }}
        </button>
      </div>
    </div> -->
</template>

<script>
import InputSearchSelector from "../InputSearchSelector.vue";
import axios from "axios";
import { mapGetters } from "vuex";

const account = localStorage.getItem("account");

export default {
  name: "CreateNewElementGroup",
  props: [
    "callQueuesGroups",
    "closeFormButton",
    "element",
    "selectedPbxElements",
    "elementsData",
    "name",
    "selectedElementsLength",
    "addElement",
    "selectedPbxElementsFromEdit",
    "isEdit",
    "groupId",
    "groupSelectedFromPbxConfiguration",
  ],
  components: {
    InputSearchSelector,
  },
  data() {
    return {
      searchElement: "",
      account,
      closeForm: true,
      form: {
        name: "",
      },
      showMessage: false,
      messageToShow: "",
      subMessageToShow: "",
      queueList: [],
      queueListSliced: [],
      extensionsList: [],
      extensionsListSliced: [],
      DIDsList: [],
      DIDsListSliced: [],
      elements: [],
      elementToRemove: "",
      sliceElements: 500,
    };
  },
  methods: {
    infiniteHandler($state) {
      setTimeout(
        function () {
          if (this.queueListSliced.length == this.elementsData.length) {
            $state.complete();
          } else {
            this.queueListSliced = this.queueListSliced.concat(
              this.elementsData.slice(
                this.sliceElements - 500,
                this.sliceElements
              )
            );
            this.sliceElements = this.sliceElements + 500;
          }
          $state.loaded();
        }.bind(this),
        1000
      );
    },
    slicedListIncludes() {
      let flag = false;
      let list = this.queueListSliced;
      for (let index = 0; index < list.length; index++) {
        const element = list[index];
        if (element.label.includes(this.searchElement)) {
          flag = true;
        }
      }
      return flag;
    },
    getPbxMap() {
      const options = {
        method: "GET",
        url: `${localStorage.getItem("apiUrl")}/api/v1.2/${this.hostName}/map`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("apiToken")}`,
        },
      };
      axios
        .request(options)
        .then((res) => {
          let obj = {};
          let objDID = {};
          let objQueue = {};
          let extensionsArray = [];
          let keysExtensions = Object.keys(res.data.extensions);
          let keysDIDs = res.data.dids;
          let keysQueue = Object.keys(res.data.call_queues);
          keysExtensions.forEach((element, index) => {
            obj = {};
            obj["value"] = keysExtensions[index];
            obj["label"] =
              keysExtensions[index] + " - " + res.data.extensions[element];
            obj["type"] = "extension";
            this.extensionsList.push(obj);
          });
          keysDIDs.forEach((element, index) => {
            objDID = {};
            objDID["value"] = element;
            objDID["label"] = element;
            objDID["type"] = "did";
            this.DIDsList.push(objDID);
          });
          keysQueue.forEach((element, index) => {
            objQueue = {};
            objQueue["value"] = keysQueue[index];
            objQueue["label"] =
              keysQueue[index] + " - " + res.data.call_queues[element].name;
            objQueue["members"] = res.data.call_queues[element].members;
            objQueue["type"] = "queue";
            this.queueList.push(objQueue);
          });
        })
        .catch((error) => {
          console.error(error);
        });
    },
    async onSubmit(msg) {
      let dataType = 4;
      let data = {};

      let elementsValue = [];
      if (this.selectedPbxElements.length > 0) {
        for (let index = 0; index < this.selectedPbxElements.length; index++) {
          const element = this.selectedPbxElements[index].value;
          elementsValue.push(element);
        }
        data = {
          name: this.form.name,
          type: dataType,
          resources: elementsValue,
        };

        try {
          const res = await axios.post(
            `${localStorage.getItem("apiUrl")}/api/v1.2/${
              this.hostName
            }/resource-groups`,
            data,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("apiToken")}`,
              },
            }
          );
          if (res) {
            this.$emit("activeBanner");
            this.$emit("success", true);
            this.$emit("successMsg", msg);
            this.$emit("closeForm");
          }
        } catch (error) {
          this.$emit("activeBanner");
          this.$emit("success", false);
          this.$emit("successMsg", "Something went wrong");
          this.$emit("closeForm");
          this.errorHandling(error);
        }
      }
    },
    async onEdit(msg) {
      let dataType = 4;
      let data = {};

      let elementsValue = [];
      if (this.selectedPbxElements.length > 0) {
        // for (let index = 0; index < this.selectedPbxElements.length; index++) {
        //  const element = this.selectedPbxElements[index].value;
        //  elementsValue.push(element);
        // }
        data = {
          name: this.form.name,
          type: dataType,
          resources: this.selectedPbxElements,
        };

        try {
          const res = await axios.put(
            `${localStorage.getItem("apiUrl")}/api/v1.2/${
              this.hostName
            }/resource-groups/${this.groupId}`,
            data,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("apiToken")}`,
              },
            }
          );
          if (res) {
            this.$emit("activeBanner");
            this.$emit("success", true);
            this.$emit("successMsg", msg);
            this.$emit("closeForm");
          }
        } catch (error) {
          this.$emit("activeBanner");
          this.$emit("success", false);
          this.$emit("successMsg", "Something went wrong");
          this.$emit("closeForm");
          this.errorHandling(error);
        }
      }
    },
    sendMessage(msg, subMsg) {
      this.showMessage = true;
      this.messageToShow = msg;
      this.subMessageToShow = subMsg;
    },
    cleanForm() {
      this.form.name = "";
      this.$emit("clearForm");
      // this.elements = [];
    },
    async getGroupData() {
      try {
        const res = await axios.get(
          `${localStorage.getItem("apiUrl")}/api/v1.2/${
            this.hostName
          }/resource-groups/${this.groupId}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("apiToken")}`,
            },
          }
        );
        if (res) {
          this.form.name = res.data.name;
        }
      } catch (error) {
        this.$emit("activeBanner");
        this.$emit("success", false);
        this.$emit("successMsg", "Something went wrong");
        this.errorHandling(error);
      }
    },
  },
  computed: {
    ...mapGetters(["hostName"]),
    selectedPbxElementsLabels() {
      return this.isEdit
        ? this.selectedPbxElements
        : this.selectedPbxElements.map(({ label }) => label);
    },
    elementsFromEdit() {
      let list = [];
      let selectedElements = this.queueList;
      if (this.isEdit) {
        list = selectedElements.filter((res) => {
          return (
            this.selectedPbxElements.indexOf(parseInt(res.value)) >= 0 ||
            this.selectedPbxElements.indexOf(res.value) >= 0
          );
        });
        for (let index = 0; index < this.selectedPbxElements.length; index++) {
          const element = this.selectedPbxElements[index];
          let idx = selectedElements.indexOf(element);
          let flag = false;
          list.forEach((res) => {
            if (res?.value == element) {
              flag = true;
            }
          });
          if (idx < 0 && !flag) {
            list.push({ value: element, label: element });
          }
        }
      }
      return list;
    },
  },
  mounted() {
    this.getPbxMap();
    this.groupId ? this.getGroupData() : "";
    if (this.name && this.name.length > 0) {
      this.form.name = this.name;
    }
  },
  watch: {
    name: function (val) {
      this.form.name = val;
    },
    selectedElementsLength: function (val) {
      this.$forceUpdate();
    },
  },
};
</script>

<style>
.elements_card_height {
  min-height: 200px;
}
</style>
